var windows = document.getElementsByClassName("section");
const perspective = 5500;
var maxAngle = 15;

//The client x and y values go from 0 to window width and height respectively
//meaning i'll need to do some calculations to then pass to the div
// document.addEventListener("pointermove", (event) => {
//     var screenCentreX = window.innerWidth / 2;
//     var screenCentreY = window.innerHeight / 2;
//     var offsetFromCentreX = ((event.clientX - screenCentreX) / screenCentreX) * maxAngle;
//     var offsetFromCentreY = ((event.clientY - screenCentreY) / screenCentreY) * maxAngle;

//     for (var i = 0; i < windows.length; i++) {
//         // windows[i].style.transform = "perspective(" + perspective + "px) rotateX(" + offsetFromCentreY * -1 + "deg) rotateY("  + offsetFromCentreX + "deg)";
//         windows[i].style.setProperty("--rotateX", -1 * offsetFromCentreY + "deg");
//         windows[i].style.setProperty("--rotateY", offsetFromCentreX + "deg");
//     }

//     document.getElementById("test-section").style.setProperty("--rotateX", -1 * offsetFromCentreY + "deg");
//     document.getElementById("test-section").style.setProperty("--rotateY", offsetFromCentreX + "deg");
// });

document.addEventListener("pointermove", (event) => {
    for (var i = 0; i < windows.length; i++) {
        // var screenCentreX = windows[i].offsetLeft - (windows[i].style.width * 50);
        // var screenCentreY = windows[i].offsetTop - (windows[i].style.height * 50);
        var screenCentreX = windows[i].getBoundingClientRect().left + windows[i].getBoundingClientRect().width / 2;
        var screenCentreY = windows[i].getBoundingClientRect().top + windows[i].getBoundingClientRect().height / 2;
        var offsetFromCentreX = ((event.clientX - screenCentreX) / screenCentreX) * maxAngle;
        var offsetFromCentreY = ((event.clientY - screenCentreY) / screenCentreY) * maxAngle * 2;

        // windows[i].style.transform = "perspective(" + perspective + "px) rotateX(" + offsetFromCentreY * -1 + "deg) rotateY("  + offsetFromCentreX + "deg)";
        windows[i].style.setProperty("--rotateX", -1 * offsetFromCentreY + "deg");
        windows[i].style.setProperty("--rotateY", offsetFromCentreX + "deg");
    }

    document.getElementById("test-section").style.setProperty("--rotateX", -1 * offsetFromCentreY + "deg");
    document.getElementById("test-section").style.setProperty("--rotateY", offsetFromCentreX + "deg");
});

// let gyroscope = new Gyroscope({ frequency: 60 });

// gyroscope.addEventListener("reading", (e) => {
//     var screenCentreX = window.innerWidth / 2;
//     var screenCentreY = window.innerHeight / 2;
//     var offsetFromCentreX = ((gyroscope.x - screenCentreX) / screenCentreX) * maxAngle;
//     var offsetFromCentreY = ((gyroscope.y - screenCentreY) / screenCentreY) * maxAngle;

//     for (var i = 0; i < windows.length; i++) {
//         windows[i].style.transform = "perspective(" + perspective + "px) rotateX(" + offsetFromCentreY * -1 + "deg) rotateY("  + offsetFromCentreX + "deg)";
//     }
// });
// gyroscope.start();